import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";

interface Props {
  to: string;
  icon: string;
  label: string;
  subtext?: string;
}

export function DashboardTile({ to, icon, label, subtext }: Props) {
  return (
    <Link
      to={to}
      className="group flex aspect-square flex-col items-center justify-center gap-1 rounded-2xl border border-slate-800 bg-slate-900 p-3 text-center transition-colors hover:border-orange-600 hover:bg-slate-800"
    >
      <Icon
        icon={icon}
        className="h-16 w-16 sm:h-24 sm:w-24"
        aria-hidden="true"
      />
      <span className="text-xs font-medium text-slate-200 sm:text-sm">
        {label}
      </span>
      {subtext && (
        <span className="text-[10px] text-slate-500 sm:text-xs">
          {subtext}
        </span>
      )}
    </Link>
  );
}
